import { defineMessages } from 'react-intl';

export default defineMessages({
    noQuoteNotes: {
        id: 'gateway.views.quote-detail.No notes associated with this quote',
        defaultMessage: 'There are no notes associated with this quote.',
    }
});
